import _classCallCheck from "/home/node/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/home/node/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/createClass.js";
import _assertThisInitialized from "/home/node/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/assertThisInitialized.js";
import _possibleConstructorReturn from "/home/node/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/possibleConstructorReturn.js";
import _getPrototypeOf from "/home/node/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/getPrototypeOf.js";
import _inherits from "/home/node/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/inherits.js";
var __jsx = React.createElement;
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import React, { Component } from 'react';
import { Modal } from "../_global";
import styled from 'styled-components';
var edgeLogo = "/static/logos/edge-logo.svg";
var chromeLogo = "/static/logos/chrome-logo.svg";
var firefoxLogo = "/static/logos/firefox-logo.svg";
import { customFonts } from "../../constants/css";
var Title = styled.h2.withConfig({
  displayName: "BrowserModal__Title",
  componentId: "sc-63181w-0"
})(["margin-top:0;font-size:2.25rem;"]);
var ModalContent = styled.div.withConfig({
  displayName: "BrowserModal__ModalContent",
  componentId: "sc-63181w-1"
})(["text-align:center;padding:2rem 4.375rem;"]);
var BrowserLinks = styled.div.withConfig({
  displayName: "BrowserModal__BrowserLinks",
  componentId: "sc-63181w-2"
})(["display:flex;justify-content:space-around;padding:1rem 2rem 0;a{display:block;text-align:center;color:#282b26;text-decoration:underline;padding-top:0.5rem;font-family:", ";> span{display:block;margin-top:0.5rem;}> img{width:95px;height:88px;}}"], customFonts.ciutadellaMed);
var BrowserModal = /*#__PURE__*/function (_Component) {
  function BrowserModal() {
    var _this;
    _classCallCheck(this, BrowserModal);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    return _possibleConstructorReturn(_this, (_this = _callSuper(this, BrowserModal, [].concat(args)), _this.state = {
      isDismissed: false,
      unsupportedBrowser: false
    }, _this.handleClose = function () {
      _this.setState({
        isDismissed: true
      });
    }, _assertThisInitialized(_this)));
  }
  _inherits(BrowserModal, _Component);
  return _createClass(BrowserModal, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      // Detect IE versions less than or equal to 11
      if (window.navigator.userAgent.match(/(MSIE|Trident)/)) {
        /* eslint-disable react/no-did-mount-set-state */
        this.setState({
          unsupportedBrowser: true
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$state = this.state,
        isDismissed = _this$state.isDismissed,
        unsupportedBrowser = _this$state.unsupportedBrowser;
      return __jsx(Modal, {
        show: unsupportedBrowser && !isDismissed,
        onClose: this.handleClose,
        width: 690,
        height: 360
      }, __jsx(ModalContent, null, __jsx(Title, null, "Get a better experience"), __jsx("p", null, "Unfortunately Internet Explorer is an outdated browser. ", __jsx("br", null), "To get the best experience using our site, please use a new browser."), __jsx(BrowserLinks, null, __jsx("div", null, __jsx("a", {
        href: "https://www.microsoft.com/en-au/windows/microsoft-edge",
        target: "_blank",
        rel: "noopener noreferrer"
      }, __jsx("img", {
        src: edgeLogo,
        alt: "Microsoft Edge"
      }), __jsx("span", null, "Download", __jsx("br", null), "Microsoft Edge"))), __jsx("div", null, __jsx("a", {
        href: "https://www.google.com/chrome/",
        target: "_blank",
        rel: "noopener noreferrer"
      }, __jsx("img", {
        src: chromeLogo,
        alt: "Google Chrome"
      }), __jsx("span", null, "Download", __jsx("br", null), "Google Chrome"))), __jsx("div", null, __jsx("a", {
        href: "https://www.mozilla.org/en-US/firefox/",
        target: "_blank",
        rel: "noopener noreferrer"
      }, __jsx("img", {
        src: firefoxLogo,
        alt: "Mozilla Firefox"
      }), __jsx("span", null, "Download", __jsx("br", null), "Mozilla Firefox"))))));
    }
  }]);
}(Component);
export default BrowserModal;